// Hook React Query para expediente del cliente en portal /clientes
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { clienteExpedienteService } from '@/services/clienteExpedienteService';

const KEYS = {
  ficha: ['cliente-ficha'] as const,
  docs: (id: string) => ['cliente-docs', id] as const,
};

export function useClienteFichaQuery() {
  return useQuery({
    queryKey: KEYS.ficha,
    queryFn: () => clienteExpedienteService.getFicha(),
    staleTime: 30_000,
  });
}

export function useClienteDocuments(expedienteId: string | undefined) {
  return useQuery({
    queryKey: KEYS.docs(expedienteId ?? ''),
    queryFn: () => clienteExpedienteService.getDocuments(expedienteId!),
    enabled: !!expedienteId,
    staleTime: 30_000,
  });
}

export function useUploadDocument(expedienteId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ file, tipoDocumento }: { file: File; tipoDocumento?: string }) =>
      clienteExpedienteService.uploadDocument(expedienteId!, file, tipoDocumento),
    onSuccess: () => {
      if (expedienteId) {
        qc.invalidateQueries({ queryKey: KEYS.docs(expedienteId) });
        qc.invalidateQueries({ queryKey: KEYS.ficha });
      }
    },
  });
}

export function useDeleteDocument(expedienteId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (fileId: string) =>
      clienteExpedienteService.deleteDocument(expedienteId!, fileId),
    onSuccess: () => {
      if (expedienteId) {
        qc.invalidateQueries({ queryKey: KEYS.docs(expedienteId) });
        qc.invalidateQueries({ queryKey: KEYS.ficha });
      }
    },
  });
}
